import request from "@/utils/request";

/**
 * @typedef ApprovalRequestState
 * @prop {RequestState} state
 * @prop {UserRole} roles
 */

/**
 * Статус заявки
 * @typedef {"new" | "prepare" | "negotiate" | "review" | "work" | "report" | "check" | "closed" | "canceled"} RequestState
 */
/**
 * Статус пользователя
 * @typedef {"admin" | "sales" | "supervisor" | "ldfd" | "traderegion" | "trademacro" | "merchmacro" | "tradecentral" | "lca" | "author"} UserRole
 */

/**
 * Схемы заявок для согласования
 * Схема представляет собой список ролей пользователей для каждого статуса заявки,
 * которые способны статус заявки изменить (с помощью подписей или согласования)
 * @returns {{states: ApprovalRequestState}}
 */
export function getRequestsSchemas(params) {
  return request({
    url: "/api/admin/approval/requests/",
    method: "get",
    params,
  });
}

/**
 * Получить схему заявки для выбранного статуса заявки
 * @param {RequestState} state
 * @returns {ApprovalRequestState}
 */
export function getRequestsScheme(state) {
  return request({
    url: `/api/admin/approval/requests/${state}/`,
    method: "get",
  });
}

/**
 * Создать или обновить схему заявки для выбранного статуса заявки
 * @param {RequestState} state
 * @param {{roles: UserRole[]}} data
 * @returns {ApprovalRequestState}
 */
export function postRequestsScheme(state, data) {
  return request({
    url: `/api/admin/approval/requests/${state}/`,
    method: "post",
    data,
  });
}
